module.exports = __webpack_public_path__ + "d5e3faa9ba6b8d8908eb53a246bc38ed.fbx";